// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5b4d3dad","239":"dfffc30e","453":"0f309214","667":"6b708f8b"}[chunkId] + ".chunk.js";
};